import { useEffect, useState } from 'react';
import supabase from './supabase';
import './style.css';

const CATEGORIES = [
  { name: 'technology', color: '#3b82f6' },
  { name: 'science', color: '#16a34a' },
  { name: 'finance', color: '#ef4444' },
  { name: 'society', color: '#eab308' },
  { name: 'entertainment', color: '#db2777' },
  { name: 'health', color: '#14b8a6' },
  { name: 'history', color: '#f97316' },
  { name: 'news', color: '#8b5cf6' },
];

// const initialFacts = [
//   {
//     id: 1,
//     text: 'React is being developed by Meta (formerly facebook)',
//     source: 'https://opensource.fb.com/',
//     category: 'technology',
//     votesInteresting: 24,
//     votesMindblowing: 9,
//     votesFalse: 4,
//     createdIn: 2021,
//   },
//   {
//     id: 2,
//     text: 'Millennial dads spend 3 times as much time with their kids than their fathers spent with them. In 1982, 43% of fathers had never changed a diaper. Today, that number is down to 3%',
//     source:
//       'https://www.mother.ly/parenting/millennial-dads-spend-more-time-with-their-kids',
//     category: 'society',
//     votesInteresting: 11,
//     votesMindblowing: 2,
//     votesFalse: 0,
//     createdIn: 2019,
//   },
//   {
//     id: 3,
//     text: 'Lisbon is the capital of Portugal',
//     source: 'https://en.wikipedia.org/wiki/Lisbon',
//     category: 'society',
//     votesInteresting: 8,
//     votesMindblowing: 3,
//     votesFalse: 1,
//     createdIn: 2015,
//   },
// ];
function App() {
  const [showForm, setShowForm] = useState(false);
  // upon fetching data, we can set the state to empty array
  // then update the fact state to populate data from database
  const [facts, setFacts] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [currentCategory, setCurrentCategory] = useState('all');

  // for supabase
  // useEffect accepts 2 arguments, a function and array or the dependency array
  // empty array means this will only run once during the App components load
  useEffect(
    function () {
      async function getFacts() {
        // to display simple message if our request is still working
        setIsLoading(true);

        let query = supabase.from('react-fact-app').select('*');
        if (currentCategory !== 'all')
          query = query.eq('category', currentCategory);

        const { data: facts, error } = await query
          .order('votesInteresting', {
            ascending: false,
          })
          .limit(1000);
        // updating the state for the values from our fetch request
        if (!error) setFacts(facts);
        else alert('There was a problem getting the data');
        setIsLoading(false);
      }
      getFacts();
    },
    [currentCategory]
  );

  return (
    <>
      <Header showForm={showForm} setShowForm={setShowForm} />
      {showForm ? (
        <NewFactForm setFacts={setFacts} setShowForm={setShowForm} />
      ) : null}
      <main className="main">
        <CategoryFilter setCurrentCategory={setCurrentCategory} />
        {isLoading ? (
          <Loader />
        ) : (
          <FactList facts={facts} setFacts={setFacts} />
        )}
      </main>
      <footer>
        <Footer />
      </footer>
    </>
  );
}

// function Counter() {
//   const [count, setCount] = useState(0);
//   return (
//     <div>
//       <span style={{ fontSize: '40px' }}>{count}</span>
//       <button
//         className="btn btn-large"
//         onClick={() => setCount(currentCount => currentCount + 1)}
//       >
//         +1
//       </button>
//     </div>
//   );
// }

function Loader() {
  return (
    <>
      <figure className="message-box">
        <figcaption className="message">Loading</figcaption>
        <img src="loader.gif" width="32" height="32" alt="spinner"></img>
      </figure>
    </>
  );
}

function Header({ showForm, setShowForm }) {
  const appTitle = 'Today I Learned';

  return (
    <header className="header">
      <div className="logo">
        <img src="logo.png" height="68" width="68" alt="Today I Learned Logo" />
        <h1>{appTitle}</h1>
      </div>

      <button
        className="btn btn-large btn-open"
        onClick={() => setShowForm(show => !show)}
      >
        {showForm ? 'Close' : 'Share a fact'}
      </button>
    </header>
  );
}

// to check if url input is valid url
function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

function NewFactForm({ setFacts, setShowForm }) {
  const [text, setText] = useState('');
  const [source, setSource] = useState('');
  const [category, setCategory] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const textLength = text.length;

  async function handleSubmit(e) {
    // 1. Prevent browser reload
    e.preventDefault();

    // 2. Check if data is valid.
    // if so, create new fact
    if (text && isValidHttpUrl(source) && category && textLength <= 200) {
      console.log('there is data');
    }

    // // 3. Create a new fact object
    // const newFact = {
    //   id: Math.round(Math.random() * 1000000),
    //   // in javascript, if the key and value is same example text : text,
    //   // we can simple use text alone, same goes to source and category
    //   text,
    //   source,
    //   category,
    //   votesInteresting: 0,
    //   votesMindblowing: 0,
    //   votesFalse: 0,
    //   createdIn: new Date().getFullYear(),
    // };

    // 3. Upload fact to Supabase and receive the new fact object

    setIsUploading(true);
    const { data: newFact, error } = await supabase
      .from('react-fact-app')
      .insert([{ text, source, category }])
      .select();
    setIsUploading(false);

    // const { data, error } = await supabase
    //   .from('react-fact-app')
    //   .insert([
    //     { some_column: 'someValue' },
    //     { some_column: 'otherValue' },
    //   ])
    //   .select()

    // 4. Add the new fact to the UI: add the fact to state
    if (!error) setFacts(facts => [newFact[0], ...facts]);

    // 5. Reset input fields
    setText('');
    setSource('');
    setCategory('');

    // 6. Close the form
    setShowForm(false);

    console.log(text, source, category);
  }

  return (
    <form className="fact-form" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Share a fact with the world..."
        value={text}
        onChange={e => {
          setText(e.target.value);
        }}
        disabled={isUploading}
      />
      <span>{200 - textLength}</span>
      <input
        type="text"
        placeholder="http://example.com"
        value={source}
        onChange={e => setSource(e.target.value)}
        disabled={isUploading}
      />
      <select
        value={category}
        onChange={e => setCategory(e.target.value)}
        disabled={isUploading}
      >
        <option value="">Choose category:</option>
        {CATEGORIES.map(cat => (
          <option key={cat.name} value={cat.name}>
            {cat.name.charAt(0).toUpperCase() + cat.name.slice(1)}
          </option>
        ))}
      </select>
      <button className="btn btn-large" disabled={isUploading}>
        Post
      </button>
    </form>
  );
}

function CategoryFilter({ setCurrentCategory }) {
  return (
    <aside>
      <ul>
        <li className="category">
          <button
            className="btn btn-all-categories"
            onClick={() => setCurrentCategory('all')}
          >
            All
          </button>
        </li>

        {CATEGORIES.map(cat => (
          <li key={cat.name} className="category">
            <button
              className="btn btn-category"
              style={{ backgroundColor: cat.color }}
              onClick={() => setCurrentCategory(cat.name)}
            >
              {cat.name}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}

function FactList({ facts, setFacts }) {
  // if no facts based on the category selected
  if (facts.length === 0)
    return (
      <p className="message">
        No facts for thos category yet! Create the first one 😉
      </p>
    );

  // display all/selected facts
  return (
    <section>
      <ul className="facts-list">
        {facts.map(fact => (
          <Fact key={fact.id} fact={fact} setFacts={setFacts} />
        ))}
      </ul>
    </section>
  );
}

function Fact({ fact, setFacts }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const isDisputed =
    fact.votesInteresting + fact.votesMindBlowing < fact.votesFalse;

  // const { data, error } = await supabase
  // .from('react-fact-app')
  // .update({ other_column: 'otherValue' })
  // .eq('some_column', 'someValue')
  // .select()

  async function handleVote(columnName) {
    setIsUpdating(true);
    const { data: updatedFact, error } = await supabase
      .from('react-fact-app')
      .update({ [columnName]: fact[columnName] + 1 })
      .eq('id', fact.id)
      .select();
    setIsUpdating(false);

    console.log(updatedFact);
    if (!error)
      setFacts(facts =>
        facts.map(f => (f.id === fact.id ? updatedFact[0] : f))
      );
  }

  return (
    <li className="fact">
      <p>
        {isDisputed ? <span className="disputed">[⛔️ DISPPUTED]</span> : null}
        {fact.text}
        <a
          className="source"
          href={fact.source}
          target="_blank"
          rel="noreferrer"
        >
          (Source)
        </a>
      </p>
      <span
        className="tag"
        style={{
          backgroundColor: CATEGORIES.find(cat => cat.name === fact.category)
            .color,
        }}
      >
        {fact.category}
      </span>
      <div className="vote-buttons">
        <button
          onClick={() => handleVote('votesInteresting')}
          disabled={isUpdating}
        >
          👍 {fact.votesInteresting}
        </button>
        <button
          onClick={() => handleVote('votesMindBlowing')}
          disabled={isUpdating}
        >
          🤯 {fact.votesMindBlowing}
        </button>
        <button onClick={() => handleVote('votesFalse')} disabled={isUpdating}>
          ⛔️ {fact.votesFalse}
        </button>
      </div>
    </li>
  );
}

function Footer() {
  return (
    <p className="copyright">
      <span>&copy; Copyright by </span>
      <a
        className="twitter-link"
        target="_blank"
        href="https://twitter.com/jonasschmedtman"
        rel="noreferrer"
      >
        Jonas Schmedtmann
      </a>
      <span>. Built by </span>
      <a
        className="github"
        target="_blank"
        href="https://github.com/Kavin-crew"
        rel="noreferrer"
      >
        KFA
      </a>
    </p>
  );
}

export default App;
